import React from 'react';
import Header from '../Components/Header/Header';

import Footer from '../Components/Footer/Footer';
import ProductDisplay from '../Components/Products/Products';



const ProductsPage = () => {
  return (
    <div>
      <Header />
      <ProductDisplay/>
      <Footer />
      
    </div>
  );
};

export default ProductsPage;
